module.exports = "static/assets/6e51f9cfc9bfca2f4fb88d1fe1ec2615.png";